package com.upcominds.expedite.di

import org.koin.core.Koin
import org.koin.core.KoinApplication
import org.koin.core.context.startKoin
import org.koin.core.module.Module

private lateinit var koinApp: KoinApplication

fun initKoin(platformModule: Module) {
    koinApp = startKoin {
        // Load both the shared module and the platform-specific module
        modules(sharedModule, platformModule)
    }
}

fun getKoin(): Koin = koinApp.koin